import React from 'react';
import { View } from 'react-native';

export const VerifiedBadge = ({ style }) => {
  return (
    <View
      style={[
        {
          position: 'absolute',
          left: -2,
          top: -2,
          width: 8,
          height: 8,
          borderRadius: 1000,
          backgroundColor: '#0bb5df',
          borderWidth: 1,
          borderColor: 'white',
          zIndex: 1
        },
        style
      ]}
    />
  );
}; 